import { createCustomerPortalSession } from "@/api/privateRequests/stripe/createCustomerPortalSession";
import { CloseIcon } from "@/components/features/SquadBuilder/RightPanel/PanelHeader/PanelHeader";
import { mixpanelTrack } from "@/events/mixpanelTrack";
import { cn } from "@/lib/utils";
import { Trans } from "@repo/shared/i18n";
import { formatTime } from "@repo/shared/utils";

export const SubscriptionExpiringBanner = ({
  cancelsAt,
  onClose,
}: {
  cancelsAt: number;
  onClose: () => void;
}) => {
  return (
    <div
      className={cn(
        "flex flex-row justify-center items-center pl-2 text-xs desktop:text-sm bg-amber-500 text-white sticky top-0 w-full z-40 cursor-pointer h-10 touch-device:h-9 transition-colors",
      )}
      onClick={() => {
        createCustomerPortalSession();
        mixpanelTrack("subscription_expiring_banner_clicked");
      }}
    >
      <div className="flex flex-row justify-between w-full text-center">
        <div className="my-auto flex items-center gap-2 overflow-hidden mx-auto">
          <span>
            <Trans
              ns="subscription"
              i18nKey="expiringBanner.text"
              values={{ time: formatTime(cancelsAt * 1000 - Date.now()) }}
              components={{ b: <span className="font-bold" /> }}
            />
          </span>
        </div>
        <button
          className="my-auto cursor-pointer fill-gray-800 px-4 py-2"
          onClick={(e) => {
            onClose();
            e.stopPropagation();
          }}
        >
          <CloseIcon color="white" />
        </button>
      </div>
    </div>
  );
};
